import classes from './Footer.module.css';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <div className={classes.footer}>
            <div className={classes.footer__columns}>
                <div className={classes.list}>
                    <h2>Quick Links</h2>
                    <ul className={classes.quick__links}>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/events">Events & Results</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/coaching">Coaching</Link></li>
                    </ul>
                </div>
                <div className={classes.list}>
                    <h2>Contact us</h2>
                    <p><Link to="https://maps.app.goo.gl/xzLgpdoD4TM6esRL8" className={classes.contactLink}><Icon icon="mdi:location" top="10" width="18" height="18" /> Galway, Ireland</Link></p>
                    <p><a href="mailto:tribalrunninggalway@gmail.com" className={classes.contactLink}><Icon icon="ic:baseline-email" width="18" height="18" /> tribalrunninggalway@gmail.com</a></p>
                    <div className={classes.socialIcons}>
                        <Link to="https://www.facebook.com/share/1941DQHtKa/">
                            <Icon icon="ic:baseline-facebook" width="28" height="28" />
                        </Link>
                        <Link to="https://www.instagram.com/tribal_running?igsh=MWhzdWpjcXRoZmpiMA==">
                            <Icon icon="mdi:instagram" width="28" height="28" />
                        </Link>
                        <Link to="https://wa.me/353872803980">
                            <Icon icon="ic:baseline-whatsapp" width="28" height="28" />
                        </Link>
                        <Link to="https://youtube.com/@tribalrunning?si=tmPrP6n2Q-_mrAoB">
                            <Icon icon="mdi:youtube" width="28" height="28" />
                        </Link>
                    </div>
                </div>
            </div>
            <p className={classes.copyright}>©2026 Tribal Running. All Rights Reserved.</p>
        </div>
    )
}
